module.exports = __webpack_public_path__ + "static/simcrest-apps-ebank-reconciliation-a3989aeea00e5ab656dc8eb583894392.png";